<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content" >
      <div>
        <div v-if="list.length != 0">
        <!-- <div class="title_older">{{$t('new_test2.Class_Enrolled')}}</div> -->
          <div class="list_content" v-for="(item,index) in list" :key="index">
            <div class="left_content">
                <div class="time_text">
                  <div class="title_content">{{item.subjects_title}}</div>
                  <div class="timecontent">
                    {{item.next_start_time}} - {{item.next_end_time}}
                    <button :class="item.status==0?'willStartIn':item.status == 1?'progress':item.status == 2?'completed':'btnNone'">
                      <span class="dot"></span>
                      {{item.status == 0?$t('new_test2.Not_Started'):(item.status==1?$t('new_test2.In_progress'):(item.status==2?$t('new_test2.Completed'):''))}}
                    </button>
                  </div>
                </div>  
              </div> 
              <div class="content_box">
                
                <div class="title_content_bom">  
                  <div class="dom">
                    <p>{{$t('new_test2.Level')}}</p> <span>{{item.level_title}}</span></div>
                  <div class="dom">
                    <p>{{$t('test2.meet')}}</p> <span>{{item.meet}}</span></div>
                  <div class="dom">
                    <p>{{$t('test2.Next_class')}}</p> <span>{{item.next_start_date}}</span></div>
                </div>
              </div>
          </div>
        </div>
          <!-- <span class="immlpnna mg">{{$t('new_test2.Student')}}: <span class="clomnerqq">{{item.nickname}}</span></span>
        
        <div class="linmear" v-for="(items,index) in item.settingFormatArr" :key="index">
          <span class="siner_colm">{{items.weekday}}&nbsp;&nbsp;&nbsp;{{items.start_at}}</span>
        </div> -->


        <div v-else class="noResultInfo">
          <p class="font_24_reg">{{$t('tabBar.noLesson')}}</p>
          <p class="font_24_reg">{{$t('tabBar.download')}}</p>
          <div class="flex_justify_center">
            <img @click="utils.toAppStore()" src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />
            <img @click="utils.toGooglePlay()" src="../../assets/google-play-badge.png" />
          </div>
        </div>



        <div class="dian"></div>
      </div>

    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
        height:100,
        tableMaxHeight:null,
        list:10,
        data: [],
        childData: [],
        interval: null,
        activeTitle: 'schedule', /* calendar */
        timeRang: Array.apply(null, Array(2)).map(() => ''), // 日期范围
        searchStudentSn: '',
        scheduleData: [],
        courseData: [],
        balanceData: {},
        lessonData: [],
        now_status: '',
        pageNum: 1,
        total: 0,
        pagesize: 10
      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.getCourse();
    },
    methods: {
      getCourse () {
        let children_id = getStore(keys.userProfile);
        // children_id.last_student_sn
        this.$http.post('/api/myCourse?student_sn=' + children_id.last_student_sn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            this.list = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
    },
    mounted () {


    },
    watch: {
      '$intercom.visible': function (val) {
        if (val == true) {
          this.updateIntercom()
        }
      },
      email (email) {
        this.$intercom.update({email})
      }
    },
  }
</script>
<style lang="less" scoped>

.left_body_content{
    // width: 358px;
  // height: 900px;
  // border: 1px solid ;
  // position: fixed;
  // top: 84px;
  // bottom: 0;
  // background: #FCFCFF;
  // border: 1px solid red;
  .left_nav_content{
    width: 358px;
    height: 900px;
    // border: 1px solid ;
    position: fixed;
    top: 84px;
    bottom: 0;
    background: #FCFCFF;
  }
  .right_content{
    // width: 400px;
    // height: 400px;
    // border: 1px solid red;
    // margin-left: 358px;
  }
}


.Scroll_content{
  // width: 1012px;
  // height: 400px;
  // border:1px solid red;
  .list_content{
    // height: 140px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.09);
    box-shadow: 0px 4px 26.64px rgba(0, 0, 0, 0.09);
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 17px;
    .left_content{
      // width: 147px;
      font-family: Sofia Pro;
      font-style: normal;
      border-bottom: 1px solid #E9E9E9;
      padding-bottom:10px;
      .time_text{
          font-size: 32px;
          margin: 12px 0 10px 33px;
          .title_content{
            font-family: Sofia Pro;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            color: #000000;
            margin-bottom:10px;
          }
          .timecontent{
            display: flex;
            align-items: center;
            button{
              margin-left:30px;
            }
          }
      }
      // .inm_xim{
      //   font-family: 'element-icons';
      //   font-style: normal;
      //   font-weight: normal;
      //   font-size: 16px;
      //   line-height: 16px;
      //   color: #A5A5A5;
      //   text-align: center;
      //   margin-top: -35px;
      // }
    }
    .content_box{
      // width: 550px;
      // height: 90px;
      border: 0px solid red;
      // margin-top: 24px;
      margin:20px 40px 20px 33px;
      flex:1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title_content_bom{
        display: flex;
        // margin-left: 35px;
        // margin-top: 19px;
        .dom{
          // margin-right: 49px;
          p{
            font-size: 20px;
            color: #000000;
          }
          span{
            font-size: 16px;
            color: #6B6B6B;
            display: block;
            min-width:162px;
            margin-top:10px;
          }
        }
      }
      
      .send_botton{
        // width: 267px;
        // height: 136px;
        display: flex;
        margin-left:30px;
        
        .bunmer{
          width: 183px;
          height: 50px;
          background: #4B4EFC;
          border-radius: 6px;
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 18px;
          line-height: 50px;
          align-items: center;
          text-align: center;
          color: #FFFFFF;
          margin-top: 16px;
          cursor: pointer;
        }
      }
    }
    
  }
} 
.siner_colm{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: right;
  display: block;
  text-align: right;
  color: #000000;
}
.llmsser{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  text-decoration-line: underline;
  color: #000000;
  cursor: pointer;
}
.immlpnna{
  // font-family: Sofia Pro;
  font-style: normal;
  // font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  align-items: center;

  color: #A5A5A5;
}
.clomnerqq{
  color: #000000 !important;
}
.mg{
  margin-left:53px;
}
  .title_older{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 27px;
    color: #000000;
    margin-top: 18px;
  }



    .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    // background: #99a9bf;
  }
  .bg-purple {
    // background: #d3dce6;
  }
  .bg-purple-light {
    // background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }


  .linmear{
    margin-bottom:20px;
  }
  .inndwer{
    display: block;
    text-align: right;
  }
.nclfons{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  /* identical to box height */
  color: #000000;
}
.inn1{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  color: #FFB800;
  margin-left: 17px;
}
.lan{
  color: #009A91 !important;
}
.huang{
  color: #FFB800 !important;
}
.hong{
  color: #FF6440 !important;
}

  .noResultInfo{
    margin-top:80px;
    text-align: center;
    p{
      margin-bottom:32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/children/ClassEnrolled.vue